module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAAECAYAAAANt+ToAAAAKUlEQVRIiWM0Njb+zzAKRsEAA6aBdsAoGAUMDKMJcRQMEjCaEEfBoAAAV9YBoKeXha0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/lineb.png
// module id = J3Ox
// module chunks = 1